import { get } from './api';
import { callNative } from '@/utils/bridge';

export async function getUserInfo(){
    try{
        const userInfo = await get('/rest/n/kmovie/app/user/info/getUserInfo')
        if(userInfo && userInfo.status === 200){
            return userInfo
        }
    }catch(e){
        return null
    }
}

export async function getTabCount(){
    try{
        const tabInfo = await get('/rest/n/kmovie/app/community/tab/count')
        console.log('tabinfo:',tabInfo)
        if(tabInfo && tabInfo.status === 200){
            return tabInfo
        }
    }catch(e){
        return null
    }
}

export async function lightCheck(){
    try{
        const lightRes = await get('/rest/n/kmovie/app/profile/light/check')
        console.log('isLight:',lightRes)
        if(lightRes && lightRes.status === 200){
            return lightRes
        }
    }catch(e){
        return null
    
    }
}

 export async function getDeviceInfo(){
    let res = {}
    try{
        res = await callNative('getInfoFromKwaiYing', {infoName: 'all'})
        console.log('base device info:',res)
    }
    catch(error){
        console.log(error)
        return null
    }
    return typeof res === 'string' ? JSON.parse(res) :res
 }


 export async function getUserContent(){
    let res = {}
    try{
        res = await callNative('userContent')
        console.log('useContentRes:',res)
    }
    catch(error){
        return null
    }
    return typeof res === 'string' ? JSON.parse(res) :res
 }


 export async function getCustomDeivceInfo(){
    let res = {}
    try{
        res = await callNative('deviceInfo')
        console.log('deviceInfoRes:',res)
    }
    catch(error){
        return null
    }
    return typeof res === 'string' ? JSON.parse(res) :res
 }

 //open author
 export async function openAuthority(){
    try{
        callNative('openAuthority', {}, false)
    }
    catch(error){
        console.log(error)
    }
 }
